import {
  Box,
  Button, CircularProgress, Container, Grid, Stack,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
// import ROUTES from '../../../../Configs/routes';

export default function Onboarding({
  classes,
  isLoading,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') {
      navigate('/');
    }
  }, [location]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <Box className="center">
              <img src={Images.Onboarding} alt="Onboarding" />
              <h3 className="mt-6 s-18">Welcome to OenoBank </h3>
              <div className="desc center mt-1 s-14">Differently Wine Storage</div>
            </Box>
            <Stack spacing={2} mt={6}>
              <Button
                disabled={isLoading}
                startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
                size="large"
                type="submit"
                variant="contained"
                className="btn-contained"
                fullWidth
                onClick={() => navigate(ROUTES.signin())}
              >
                Sign In
              </Button>
              <Button
                size="large"
                type="submit"
                variant="outlined"
                className="btn-outlined"
                fullWidth
                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                onClick={() => navigate(ROUTES.market())}
              >
                <img src={Images.ShoppingBag} alt="market" />
                OenoMarket
              </Button>
            </Stack>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
